import { EventEmitter } from '@angular/core';
import { MessageType } from '../models/message';
import { AppConfigService } from './app-config.service';
import { StringHelper } from '../utils/string-helper';
import * as i0 from "@angular/core";
var MessageService = /** @class */ (function () {
    /**
     * Creates an instance of MessageService.
     * @param {AppConfigService} appConfig
     * @memberof MessageService
     */
    function MessageService() {
        /**
         * Current messages
         *
         * @type {IMessage[]}
         * @memberof MessageService
         */
        this._messages = [];
        /**
         * Message EventEmitter
         *
         * @memberof MessageService
         */
        this.messages = new EventEmitter(true);
    }
    /**
     * Create a pseudo Guid
     *
     * @private
     * @static
     * @returns {string}
     * @memberof MessageService
     */
    MessageService.createMessageId = function () {
        var seconds = Math.floor((new Date()).getTime() / 1000);
        return String(seconds) + '-' + StringHelper.getRandom();
    };
    /**
     * add a new message
     *
     * @param {string} text
     * @param {MessageType} type
     * @param {string} [id=null]
     * @memberof MessageService
     */
    MessageService.prototype.add = function (text, type, id) {
        if (id === void 0) { id = null; }
        // message
        if (type !== MessageType.Debug || AppConfigService.settings.debug) {
            if (id === null) {
                this._messages.push({ id: MessageService.createMessageId(), text: text, type: type });
            }
            else if (this._messages.filter(function (msg) { return msg.id === id; }).length === 0) {
                // add if no already exists
                this._messages.push({ id: id, text: text, type: type });
            }
            this.broadcast();
        }
        // console output
        if (AppConfigService.settings.debug) {
            this.writeToConsole({ id: id, text: text, type: type });
        }
    };
    /**
     * Remove any message by id
     *
     * @param {string} messageId
     * @memberof MessageService
     */
    MessageService.prototype.remove = function (messageId) {
        var _this = this;
        var indexes = [];
        this._messages.forEach(function (message, i) {
            if (message.id === messageId) {
                indexes.push(i);
            }
        });
        indexes.forEach(function (element) {
            _this._messages.splice(element, 1);
        });
        this.broadcast();
    };
    /**
     * Clear all messages
     *
     * @memberof MessageService
     */
    MessageService.prototype.clear = function () {
        this._messages = [];
        this.broadcast();
    };
    /**
     * Emitts the current messages to the listeners
     *
     * @private
     * @memberof MessageService
     */
    MessageService.prototype.broadcast = function () {
        this.messages.next(this._messages);
    };
    /**
     * Write messages to console
     *
     * @private
     * @param {IMessage} message
     * @memberof MessageService
     */
    MessageService.prototype.writeToConsole = function (message) {
        switch (message.type) {
            case MessageType.Error:
                console.error(message.text);
                break;
            case MessageType.Waning:
                console.warn(message.text);
                break;
            default:
                console.log(message.text);
        }
    };
    MessageService.ngInjectableDef = i0.defineInjectable({ factory: function MessageService_Factory() { return new MessageService(); }, token: MessageService, providedIn: "root" });
    return MessageService;
}());
export { MessageService };
